require('intersection-observer');

let mobile = false;
if (window.matchMedia('(max-width:1025px)').matches) {
  mobile = true;
}

//intersection observer

const iSObserversA = document.querySelectorAll('.iSObserver');
const iSObservers = Array.prototype.slice.call(iSObserversA, 0);
const options = {
  rootMargin: '-20% 0px',
};

const fadeIn = (target) => {
  target.classList.add('op');
};

const observeUse = (entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      fadeIn(entry.target);
    }
  });
};

const observer = new IntersectionObserver(observeUse, options);
iSObservers.forEach(iSObserver => {
  observer.observe(iSObserver);
});

const heightChange = () => {
  let sec3H = window.innerHeight - 60;
  $('.rp9Section3 .rp9Section3__flex').css('height', sec3H);
  $('.rp9Section4 .rp9Section4__flex').css('height', sec3H);
  $('.rp9Section5__main').css('height', sec3H);
};

const tabImg = () => {
  $('.rp9Section4__innerTab').on('click', (e) => {
    $('.rp9Section4__innerTab').removeClass('rp9Section4__innerTab-active');
    $(e.currentTarget).addClass('rp9Section4__innerTab-active');
    const num = $(e.currentTarget).attr('id').split('-')[1];
    const imgId = `#tabImg-${num}`;
    $('.rp9Section4__innerRightImg').hide();
    if (imgId === '#tabImg-1') {
      $('.rp9Section4__innerRight').removeClass('rp9Section4__innerRight-model2');
    } else {
      $('.rp9Section4__innerRight').addClass('rp9Section4__innerRight-model2');
    }
    $(imgId).show();
  });
};

tabImg();

const upImgFunc = () => {
  $('#upImg').on('click', () => {
    const getId = $('.rp9Section4__innerTabs > .rp9Section4__innerTab-active').attr('id').split('-')[1];
    const showId = `#modalImg-${getId}`;
    $(showId).show();
    
    $('#menu').hide();
    // $('.section').hide();
    // $('.rp9Section4').show();
    $('.rp9Section4__innerRightModal').fadeIn();
  });
};

upImgFunc();

$('.rp9Section4__innerRightModal').on('click', (e) => {
  if ($(e.target).hasClass('rp9Section4__innerRightModal')) {
    // $('.section').show();
    $('.rp9Section4__innerRightModal').fadeOut();
    $('.rp9Section4__innerRightModalImg').fadeOut();

    if (!mobile) {
      $('#menu').show();
    }

  }
});

$('.rp9Section4__modalClose').on('click', (e) => {
  $('.rp9Section4__innerRightModal').fadeOut();
  $('.rp9Section4__innerRightModalImg').fadeOut();

  if (!mobile) {
    $('#menu').show();
  }
});



// fullpage
var fixClass = 'fixed';
var $nav = $('#headerNav');
if (mobile) {} else {
  $(document).ready(function () {
    // $('#fullpage').fullpage({
    //   anchors: ['section1', 'section2', 'section3', 'section4', 'section5', 'section6', 'section7'],
    //   menu: '#menu',
    //   paddingTop: '60px',
    //   scrollingSpeed: 500,
    //   scrollOverflowReset: true,
    //   afterLoad: function (anchorLink, index) {
    //     if (index === 1) {
    //       $('#menu').addClass('rp9Menu-top');

    //     }
    //   },
    //   onLeave: function (index, nextIndex) {
    //     //セクションが読み込み終わりのイベント  
    //     if (nextIndex === 1) {
    //       $('#menu').addClass('rp9Menu-top');
    //       $nav.removeClass(fixClass);
    //       $('#breadCrumbs').show();
    //       $('#headerWrap').show();
    //       $('#headerLow').css('height', '150px');
    //       $('.rp9Section1__header').css('height', '240px')

    //     } else {
    //       $('#menu').removeClass('rp9Menu-top');
    //       $nav.addClass(fixClass);
    //       $('#breadCrumbs').hide();
    //       $('#headerWrap').hide();
    //       $('#headerLow').css('height', '60px');
    //       $('.rp9Section1__header').css('height', '60px')
    //     }
    //   },
    // });

    new fullpage('#fullpage', {
      licenseKey: 'F95B8B97-6D0E4382-95C48A53-39E8375C',
      scrollOverflow: true,
      scrollOverflowReset: true,
      scrollOverflowResetKey: 'nNjeWNsZS5jby5qcF85TUVjMk55YjJ4c1QzWmxjbVpzYjNkU1pYTmxkQT09cktR',

      anchors: ['section1', 'section2', 'section3', 'section4', 'section5', 'section6', 'section7'],
      menu: '#menu',
      paddingTop: '60px',
      scrollingSpeed: 500,
      afterLoad: function (anchorLink, index) {
        if (index.anchor === 'section1') {
          $('#menu').addClass('rp9Menu-top');
        }
        if (index.anchor === 'section7') {
          $('.rp9__scrollImg').css('opacity', 0);
        }
      },
      onLeave: function (index, nextIndex) {
        //セクションが読み込み終わりのイベント  
        if (nextIndex.anchor === 'section1') {
          $('#menu').addClass('rp9Menu-top');
          $nav.removeClass(fixClass);
          $('#breadCrumbs').show();
          $('#headerWrap').show();
          $('#headerLow').css('height', '150px');
          $('.rp9Section1__header').css('height', '240px');
        } else {
          $('#menu').removeClass('rp9Menu-top');
          $nav.addClass(fixClass);
          $('#breadCrumbs').hide();
          $('#headerWrap').hide();
          $('#headerLow').css('height', '60px');
          $('.rp9Section1__header').css('height', '60px');
        }

          if (nextIndex.anchor === 'section7'){
            $('.rp9__scrollImg').css('opacity', 0);
          } else {
            $('.rp9__scrollImg').css('opacity', 1);
          }
      }
  
  });

    heightChange();

    let posi = 0;
    $('.rp9Section3__innerLi').on('click', function () {

      if ($(this).hasClass('next')) {
        posi += -100;
      } else if ($(this).hasClass('back')) {
        posi += 100;
      }
      $('.rp9Section3__flex').css('transform', `translateX(${posi}vw)`);
    });
  });
}

window.addEventListener('resize', () => {
  let url = new URL(window.location.href);
  if (window.matchMedia('(max-width:767px)').matches) {
    if (!mobile) {
      mobile = true;
      history.replaceState('', '', url.pathname);
      location.reload();
    }
  } else {
    if (mobile) {
      mobile = false;
      history.replaceState('', '', url.pathname);
      location.reload();
    }
  }
  if (!mobile) {
    heightChange();
  }
});